package fr.frux.core.common.share

/**
 * Contenu prêt à passer à [ShareLauncher.share] pour une fiche arbre (#391). Séparé du launcher
 * lui-même pour rester testable sans dépendre d'une plateforme : seule la composition du texte a
 * une règle métier (espèce seule, jamais de lieu ni de pseudo, cf. issue #391), le launcher n'est
 * qu'un tuyau.
 */
data class TreeShareContent(
    val title: String,
    val text: String,
    val url: String,
)

/**
 * Construit le texte de partage d'une fiche arbre à partir du seul nom d'espèce et de l'URL
 * publique de la fiche : ni coordonnées, ni commune, ni pseudo du contributeur (règle produit
 * actée sur #391, ADR 0015 — la localisation précise ne se diffuse pas hors de l'app).
 *
 * Exemple pour "Pommier" : titre « Pommier sur Frux », texte « Pommier, à retrouver sur Frux, la
 * carte de la cueillette. ». Le texte ne contient pas l'URL : c'est chaque launcher qui la place
 * là où sa plateforme l'attend (ligne finale du message, objet séparé sur iOS et Web Share), sinon
 * elle sortirait deux fois. Pas d'article ni de participe devant le nom d'espèce : « ortie » et
 * « pommier » ne s'accordent pas pareil, et le référentiel ne porte pas le genre.
 */
fun buildTreeShareContent(
    speciesName: String,
    treeUrl: String,
): TreeShareContent =
    TreeShareContent(
        title = "$speciesName sur Frux",
        text = "$speciesName, à retrouver sur Frux, la carte de la cueillette.",
        url = treeUrl,
    )
